import { Component } from "../../components/base/Component";
import { ICfa } from "../../models/ICfa";
import { ComponentFactory } from "../../services/ComponentFactory";
import { LoadingSpinner } from "../../CFACom";
// import * as bundleCARES from "./bundleCARES.js";

export class CaresContainer extends Component {
	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);
		const loadingClass = "cares-loading";
		_element.classList.add(loadingClass);
		LoadingSpinner.start("cares-spinner");
		const script = this.mountScript();
		script.onload = () => {
			const MyApp = (window as any).MyApp;
			if (typeof MyApp !== "undefined") {
				const id = this._element.getAttribute("id");
				MyApp.renderApp(id);
			} else {
				console.error("MyApp is not defined");
			}
			_element.classList.remove(loadingClass);
			LoadingSpinner.stop("cares-spinner");
		};
	}

	mountScript(): HTMLScriptElement {
		console.log("Mounting CARES script");
		const script = document.createElement("script");
		const scriptName = this.getScriptName();
		script.src = scriptName;
		script.async = true;
		document.head.appendChild(script);

		return script;
	}

	getScriptName(): string {
		return (
			this._element.getAttribute("data-script") ||
			`/js/bundleCARES.js?v=${Date.now().valueOf()}`
		);
	}
}

ComponentFactory.registerComponent("CaresContainer", CaresContainer);
